import { useQuery } from "@tanstack/react-query";

import { getSports } from "@/services";

import { EventStatus } from "../types";

export const useSports = (status?: EventStatus) =>
  useQuery({
    queryKey: ["sports", status],
    queryFn: () => getSports(status),
    refetchInterval: 10_000,
  });
